
    import * as React from 'react';

    const Location16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M10.304 6a2.304 2.304 0 11-4.608 0 2.304 2.304 0 014.608 0zm-.75 0a1.554 1.554 0 10-3.108 0 1.554 1.554 0 003.108 0zm3.321-.09c0 .857-.233 1.681-.671 2.418L8 15.066l-.318-.51-3.89-6.235a4.696 4.696 0 01-.667-2.41c0-2.645 2.184-4.786 4.875-4.786s4.875 2.14 4.875 4.786zm-1.312 2.027a3.946 3.946 0 00.562-2.026c0-2.228-1.845-4.036-4.125-4.036-2.28 0-4.125 1.809-4.125 4.036 0 .718.196 1.41.558 2.02L8 13.649l3.563-5.712z" /></svg>
        </div>
      );
    };

    Location16.displayName = 'Location16';

    export default Location16;
  